import React, { useState } from 'react';
import { Clock, TrendingUp } from 'lucide-react';
import { coursesData } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const Courses = () => {
  const [hoveredCourse, setHoveredCourse] = useState(null);

  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="asignaturas" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            {coursesData.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {coursesData.subtitle}
          </p>
        </div>

        {/* Courses Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {coursesData.courses.map((course) => (
            <Card
              key={course.id}
              className="group bg-gray-900 border-gray-800 hover:border-amber-500/50 overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/20 hover:-translate-y-2"
              onMouseEnter={() => setHoveredCourse(course.id)}
              onMouseLeave={() => setHoveredCourse(null)}
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={course.image}
                  alt={course.name}
                  className={`w-full h-full object-cover transition-transform duration-500 ${
                    hoveredCourse === course.id ? 'scale-110' : 'scale-100'
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40 to-transparent"></div>
                
                {/* Course Name Overlay */}
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold text-white mb-1">
                    {course.name}
                  </h3>
                </div>
              </div>

              <CardContent className="p-6">
                {/* Description */}
                <p className="text-gray-300 mb-6 min-h-[60px]">
                  {course.description}
                </p>

                {/* Info Pills */}
                <div className="flex flex-wrap gap-2 mb-6">
                  <div className="flex items-center space-x-1 px-3 py-1 bg-gray-800 rounded-full text-sm">
                    <TrendingUp size={14} className="text-amber-500" />
                    <span className="text-gray-300">{course.levels}</span>
                  </div>
                  {course.duration && (
                    <div className="flex items-center space-x-1 px-3 py-1 bg-gray-800 rounded-full text-sm">
                      <span className="text-gray-300">{course.duration}</span>
                    </div>
                  )}
                </div>

                {/* CTA Button */}
                <Button 
                  onClick={scrollToContact}
                  className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/50"
                >
                  Más Información
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
